import { Fragment } from 'react'
import { useLocation } from 'react-router-dom';
import { Heading } from 'rsuite'

const PageTitle = ({ pageName = [] }) => {
    const location = useLocation();
    let defaultPageName = pageName;
    if(!defaultPageName.length) {
        const pathNameArray = location.pathname.split("/").filter(Boolean);
        defaultPageName = pathNameArray.map(page => page.replaceAll("-"," "));
    }
    return (
        <Heading level={4} className="fs-20 text-transform-capitalize">
            {defaultPageName.map((name, index) => {
                return <Fragment key={`${name}_${index}`}>{index !== 0 ? name : <span className="fw-300 op-05">{name}{ defaultPageName.length > 1 ?' / ':''} </span>}</Fragment>
            })}
        </Heading>
    )
}

export default PageTitle